/**
 * Template: Product
 * -----------------------------------------------------------------------------
 * Used to import styles and components for all product templates.
 *
 */
import '@/templates/product.scss'

document.addEventListener('DOMContentLoaded', () => {
  // Not empty
})
